var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/services/serviceAbstract.ts
import UtilFetch from "@dia-ui/util_fetch";
var ServiceAbstract = class {
  /**
   * Constructor
   * @param {string} apiUrl
   */
  constructor(apiUrl) {
    /**
     * ENDPOINT
     * @protected
     */
    this.API = "";
    this.API = apiUrl;
  }
  /**
   * post
   * @param {string} url
   * @param json
   * @return {Promise<DiaLabelPrintApiResult>}
   */
  call(url = "", json) {
    return __async(this, null, function* () {
      return this.callApi(url, "POST", json);
    });
  }
  /**
   * callApi
   * @param url
   * @param method
   * @param json
   * @private
   */
  callApi(url, method = "POST", json) {
    return __async(this, null, function* () {
      let initConfig = {
        method,
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        redirect: "follow",
        referrerPolicy: "no-referrer",
        progress: true,
        headers: {
          "Content-Type": "application/json"
        }
      }, processKey = "label-print-api";
      if (method === "POST") {
        initConfig["body"] = JSON.stringify(json) || "{}";
      }
      return yield UtilFetch.create(this.getApiUrl(url), initConfig, processKey);
    });
  }
  /**
   * getUrl
   * @param url
   * @private
   * @return string
   */
  getApiUrl(url) {
    return this.API.concat(url);
  }
  /**
   * getFormDataAsJson
   * @protected
   */
  getFormDataAsJson(form) {
    let jsonObject = {};
    if (form && form.elements) {
      Array.from(form.elements).map((element) => {
        if (element.hasAttribute("name")) {
          let name = element.getAttribute("name");
          if (name.indexOf("[") !== -1) {
            name = name.replace("[]", "");
            if (!jsonObject[name]) {
              jsonObject[name] = [];
            }
            let _value = element.value;
            if (_value.indexOf("{") !== -1) {
              _value = JSON.parse(_value);
            }
            jsonObject[name].push(_value);
          } else {
            jsonObject[name] = element.value;
          }
        }
      });
    }
    return jsonObject;
  }
  /**
   * translateMappedField
   * @param object
   * @param targetPath
   * @param value
   * @private
   */
  translateMappedField(object, targetPath, value) {
    let currentPathEntry = targetPath.shift();
    if (targetPath.length > 0) {
      object[currentPathEntry] = object[currentPathEntry] || {};
      this.translateMappedField(object[currentPathEntry], targetPath, value);
    } else {
      object[currentPathEntry] = value;
    }
  }
  /**
   * serializeFormData
   */
  serializeFormData(form) {
    let json = this.getFormDataAsJson(form), serialized = {}, mapped = {};
    Object.keys(this.serializeMappedFields).map((key) => {
      let target = this.serializeMappedFields[key], targetPath = target.split(":");
      this.translateMappedField(mapped, targetPath, json[key]);
    });
    this.serializeExtractFields.map((value) => {
      serialized[value] = json[value];
      delete json[value];
    });
    if (this.serializeJSONFields.length > 0) {
      serialized[this.serializeKey + "-json"] = Object.fromEntries(Object.entries(json).filter(([value]) => this.serializeJSONFields.includes(value)));
    }
    return Object.assign(serialized, mapped);
  }
};

// src/services/serviceLabel.ts
var ServiceLabel = class extends ServiceAbstract {
  /**
   * Constructor
   * @param {string} apiUrl
   */
  constructor(apiUrl) {
    super(apiUrl);
    /**
     * URLS
     * @private
     */
    this.URLS = {
      ALL: "datatable/getDataFromTable",
      GET: "labelsprint/getlabel",
      COPY: "labelsprint/copylabel",
      SAVE: "labelsprint/savelabel",
      DELETE: "labelsprint/deletelabel",
      PREVIEW: "labelsprint/getlabelpreview",
      PREVIEW_PDF: "labelsprint/getlabelsprintpreview",
      PDF: "labelsprint/createlabelspdf"
    };
    /**
     * serializeExtractFields
     * @protected
     */
    this.serializeExtractFields = [
      "label-desc",
      "label-id",
      "label-items",
      "template-id"
    ];
    /**
     * serializeJSONFields
     * @protected
     */
    this.serializeJSONFields = [
      //"width",
      //"height"
    ];
    /**
     * serializeMappedFields
     * @protected
     */
    this.serializeMappedFields = {
      //"label-width": "label-json:width",
      //"label-height": "label-json:height"
    };
    /**
     * serializeKey
     * @protected
     */
    this.serializeKey = "label";
  }
  /**
   * getAll
   */
  getAll() {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.ALL, {
        "tableClass": "LabelsPrintLabelsTableSource",
        "params": {
          "length": -1
        }
      });
    });
  }
  /**
   * get
   */
  get(id) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.GET, {
        "label-id": id
      });
    });
  }
  /**
   *
   * @param id
   */
  copy(id) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.COPY, {
        "label-id": id
      });
    });
  }
  /**
   * save
   */
  save(form) {
    return __async(this, null, function* () {
      let json = this.serializeFormData(form);
      return yield this.call(this.URLS.SAVE, json);
    });
  }
  /**
   * delete
   */
  delete(id) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.DELETE, {
        "label-id": id
      });
    });
  }
  /**
   * preview
   */
  preview(json) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.PREVIEW, json);
    });
  }
  /**
   * pdfPreview
   */
  pdfPreview(json) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.PREVIEW_PDF, json);
    });
  }
  /**
   * pdf
   */
  pdf(json) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.PDF, json);
    });
  }
};

// src/services/serviceTemplate.ts
var ServiceTemplate = class extends ServiceAbstract {
  /**
   * Constructor
   * @param {string} apiUrl
   */
  constructor(apiUrl) {
    super(apiUrl);
    /**
     * URLS
     * @protected
     */
    this.URLS = {
      ALL: "datatable/getDataFromTable",
      GET: "labelsprint/gettemplate",
      COPY: "labelsprint/copytemplate",
      SAVE: "labelsprint/savetemplate",
      DELETE: "labelsprint/deletetemplate",
      PREVIEW: "labelsprint/gettemplatepreview"
    };
    /**
     * serializeExtractFields
     * @protected
     */
    this.serializeExtractFields = [
      "template-desc",
      "template-id"
    ];
    /**
     * serializeJSONFields
     * @protected
     */
    this.serializeJSONFields = [
      "page-format",
      "width",
      "height",
      "margin-top",
      "margin-left",
      "label-width",
      "label-height",
      "label-nr-x",
      "label-nr-y",
      "label-distance-x",
      "label-distance-y",
      "label-usage"
    ];
    /**
     * serializeMappedFields
     * @protected
     */
    this.serializeMappedFields = {};
    /**
     * serializeKey
     * @protected
     */
    this.serializeKey = "template";
  }
  /**
   * getAll
   */
  getAll() {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.ALL, {
        "tableClass": "LabelsPrintTemplatesTableSource",
        "params": {
          "length": -1
        }
      });
    });
  }
  /**
   * get
   */
  get(id) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.GET, {
        "template-id": id
      });
    });
  }
  /**
   * copy
   * @param id
   */
  copy(id) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.COPY, {
        "template-id": id
      });
    });
  }
  /**
   * save
   */
  save(form) {
    return __async(this, null, function* () {
      let json = this.serializeFormData(form);
      return yield this.call(this.URLS.SAVE, json);
    });
  }
  /**
   * delete
   */
  delete(id) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.DELETE, {
        "template-id": id
      });
    });
  }
  /**
   * preview
   */
  preview(json) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.PREVIEW, json);
    });
  }
};

// src/services/serviceFeature.ts
var ServiceFeature = class extends ServiceAbstract {
  /**
   * Constructor
   * @param {string} apiUrl
   */
  constructor(apiUrl) {
    super(apiUrl);
    /**
     * URLS
     * @protected
     */
    this.URLS = {
      SEARCH: "labelsprint/searchfeature"
    };
    /**
     * serializeExtractFields
     * @protected
     */
    this.serializeExtractFields = [];
    /**
     * serializeJSONFields
     * @protected
     */
    this.serializeJSONFields = [];
    /**
     * serializeMappedFields
     * @protected
     */
    this.serializeMappedFields = {};
    /**
     * serializeKey
     * @protected
     */
    this.serializeKey = "feature";
  }
  /**
   * search
   */
  search(searchKey, templateId = 0) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.SEARCH, {
        "search-key": searchKey,
        "template-id": templateId
      });
    });
  }
};

// src/services/serviceItem.ts
var ServiceItem = class extends ServiceAbstract {
  /**
   * Constructor
   * @param {string} apiUrl
   */
  constructor(apiUrl) {
    super(apiUrl);
    /**
     * URLS
     * @protected
     */
    this.URLS = {
      GET: "labelsprint/getitemdata"
    };
    /**
     * serializeExtractFields
     * @protected
     */
    this.serializeExtractFields = [
      "item-id",
      "item-desc",
      "template-id"
    ];
    /**
     * serializeJSONFields
     * @protected
     */
    this.serializeJSONFields = [
      "source-type",
      "source-id",
      "display-type",
      "display-type-sub-option",
      "width",
      "height",
      "x",
      "y",
      "font-type",
      "font-size",
      "color",
      "text-align"
    ];
    /**
     * serializeMappedFields
     * @protected
     */
    this.serializeMappedFields = {};
    /**
     * serializeKey
     * @protected
     */
    this.serializeKey = "item";
  }
  /**
   * get
   */
  get(param, templateId = 0, itemId = null) {
    return __async(this, null, function* () {
      let json = {};
      if (itemId != null) {
        json["item-id"] = itemId;
      }
      Object.values(["source-id", "source-type", "display-type", "display-type-sub-option"]).forEach((paramKey) => {
        if (param[paramKey]) json[paramKey] = param[paramKey];
      });
      json["template-id"] = templateId;
      return yield this.call(this.URLS.GET, json);
    });
  }
};

// src/services/serviceArticle.ts
var ServiceArticle = class extends ServiceAbstract {
  /**
   * Constructor
   * @param {string} apiUrl
   */
  constructor(apiUrl) {
    super(apiUrl);
    /**
     * URLS
     * @protected
     */
    this.URLS = {
      ALL: "datatable/getDataFromTable",
      DELETE: "labelsprint/deletearticles"
    };
    /**
     * serializeExtractFields
     * @protected
     */
    this.serializeExtractFields = [];
    /**
     * serializeJSONFields
     * @protected
     */
    this.serializeJSONFields = [];
    /**
     * serializeMappedFields
     * @protected
     */
    this.serializeMappedFields = {};
    /**
     * serializeKey
     * @protected
     */
    this.serializeKey = "article";
  }
  /**
   * getAll
   */
  getAll() {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.ALL, {
        "tableClass": "LabelsPrintArticlesTableSource",
        "params": {
          "length": -1
        }
      });
    });
  }
  /**
   * delete
   */
  delete(ids) {
    return __async(this, null, function* () {
      return yield this.call(this.URLS.DELETE, {
        "items": typeof ids === "string" ? [ids] : ids
      });
    });
  }
};

// src/utilLabelPrintApi.ts
var UtilLabelPrintApi = class {
  /**
   * Constructor
   * @param {string} baseUrl
   */
  constructor(baseUrl) {
    /**
     * @private
     * @type {string}
     */
    this.apiUrl = "";
    this.apiUrl = baseUrl;
  }
  /**
   * getServiceArticle
   */
  getServiceArticle() {
    return new ServiceArticle(this.apiUrl);
  }
  /**
   * getServiceLabel
   */
  getServiceLabel() {
    return new ServiceLabel(this.apiUrl);
  }
  /**
   * getServiceTemplate
   */
  getServiceTemplate() {
    return new ServiceTemplate(this.apiUrl);
  }
  /**
   * getServiceFeature
   */
  getServiceFeature() {
    return new ServiceFeature(this.apiUrl);
  }
  /**
   * getServiceItem
   */
  getServiceItem() {
    return new ServiceItem(this.apiUrl);
  }
};

// src/index.ts
var src_default = UtilLabelPrintApi;
export {
  src_default as default
};
